export const DEFAULT_STATS = {
    enrollments: 0,
    groups: 0,
    bundles: 0,
    kpis: {
        completedOnTimeCourses: 0,
        lateCompletionCourses: 0,
        completionFailedCourses: 0,
        inProgressCourses: 0,
        notStartedCourses: 0,
        defaulterCourses: 0,
    },
};


export const STATUS_OPTIONS = ["Completed", "In Progress", "Not Started"];

export const FILTER_TYPE_OPTIONS = [
    { value: "INDIVIDUAL", label: "Individuals" },
    { value: "GROUP", label: "Group" },
];

export const SUB_TYPE_OPTIONS = [
    { value: "BUNDLE", label: "Curriculum" },
    { value: "COURSE", label: "Course" },
];


export const STATUS_FILTER_OPTIONS = [
    ...STATUS_OPTIONS.map((s) => ({ value: s, label: s })),
];
